<template>
  <section v-if="props.data?.results?.length === 0 && !loadingTable">
    No se encontraron resultados. Por favor, prueba modificando tus filtros.
  </section>

  <a-table
    v-else
    row-key="id"
    size="middle"
    ref="tableRef"
    class="emails-table"
    :columns="emailsTableColumns"
    :data-source="props.data.results"
    :loading="loadingTable"
    :scroll="scrollStyle"
    :pagination="pagination"
    :row-selection="rowSelection"
    @change="handleTableChange"
  >
    <!-- :row-selection="rowSelection" -->
    <template #headerCell="{ column, title }">
      <template v-if="column.info">
        {{ title }}
        <a-tooltip :title="column.info" placement="top">
          <InfoCircleOutlined style="margin-left: 4px; color: rgba(0, 0, 0, 0.45); cursor: pointer;" />
        </a-tooltip>
      </template>
    </template>

    <template #email="{ record }">
      <span v-if="record.email">
        <a-tooltip :title="record.email" placement="top">
          <span class="email-truncate">
            {{ record.email }}
          </span>
        </a-tooltip>
      </span>
      <span v-else>-</span>
    </template>

    <template #strategy_name="{ record }">
      {{ record?.strategy_name ? record.strategy_name : "-" }}
    </template>
    <template #id="{ record }">
      <span>#{{ record.id }}</span>
    </template>

    <template #statusSent="{ record }">
      <email-state-tag :state="record.statusSent" />
    </template>

    <template #contact="{ record }">
      <a-space class="contact-space" v-if="record.contact">
        <profile-image
          :photo="record.contact?.profile_picture"
          :name="record.contact?.fullname"
          size="small"
        />
        <a-button
          class="table-link-button contact-button"
          type="link"
          @click="handleOpenContactDrawer(record.contact.id, record.portfolio)"
        >
          {{ record.contact?.fullname }}
        </a-button>
      </a-space>

      <span v-else> No identificado </span>
    </template>

    <template #managedBy="{ record: { user_assigned } }">
      <a-space v-if="user_assigned">
        <div class="user_profile_wrapper" :style="backGroundImageColor(user_assigned)">
          <img
            v-if="user_assigned?.profile_picture"
            :src="user_assigned?.profile_picture"
            class="user_profile_picture"
            alt="profile image"
          />
          <img
            v-else
            :src="imageDefault(user_assigned)"
            alt="profile image"
            class="user_profile_default"
            :class="{ agent: user_assigned?.role === 'Agente' }"
          />
        </div>

        <a-button
          class="table-link-button"
          type="link"
          @click="handleOpenUserModal(user_assigned.fullname, user_assigned.id)"
        >
          {{ user_assigned?.fullname }}
        </a-button>
      </a-space>

      <span v-else> - </span>
    </template>

    <template #ticket="{ record: { ticket } }">
      <a-button
        v-if="ticket"
        class="table-link-button contact-button"
        type="link"
        @click="handleOpenTicketHistoryDrawer(ticket)"
      >
        #{{ ticket }}
      </a-button>
      <span v-else>-</span>
    </template>

    <template #tags="{ record: { tags } }">
      <TicketTagsList :tags="tags" />
    </template>

    <template #emailType="{ record: { emailType } }">
      <span v-if="emailType == 1">Inbound</span>
      <span v-else-if="emailType == 2">Outbound</span>
    </template>

    <template #actions="{ record }">
      <a-space :size="14" style="margin-left: 10px">
        <!-- TODO: Después de estandarizar componentes. Si el campo "record.visiblePopover" se utilizaba únicamente para cerrar el popover
         al hacer clic en otro botón de la aplicación, considerar eliminarlo ya que ahora el trigger es 'hover'. -->
        <a-popover placement="leftTop" trigger="hover" v-model:open="record.visiblePopover">
          <template #content>
            <div class="popover-content">
              <ul>
                <li>
                  <!-- <TagsList
                    :multipleElementTags="[record.tag?.map((t) => t.id)] || []"
                    :isActionTable="true"
                    @selectTags="handleSelectTags($event, record.id)"
                  /> -->
                  <TagsList
                    isActionTable
                    simple-tag
                    :currentTags="record.tags?.map((t) => t.id) || []"
                    @selectTags="handleSelectTags($event, record.id)"
                  />
                </li>
                <li>
                  <a-popover v-if="!isEmailResolved(record)" trigger="click" placement="left">
                    <template #content>
                      <div class="popover-content">
                        <ul>
                          <li>
                            <a-button type="text" @click="transferEmailUser(record)"
                              >Transferir a un usuario</a-button
                            >
                          </li>
                          <li>
                            <a-button type="text" @click="transferEmailCampaign(record)"
                              >Transferir a otra bandeja</a-button
                            >
                          </li>
                        </ul>
                      </div>
                    </template>
                    <a-button type="text" @click.stop>
                      <SwapOutlined />
                      Transferir correo
                    </a-button>
                  </a-popover>
                  <a-button v-else type="text" disabled @click.stop>
                    <SwapOutlined />
                    Transferir correo
                  </a-button>
                </li>
                <li>
                  <a-button type="text" @click="handleOpenEmailHistoryDrawer(record)">
                    <InfoCircleOutlined />
                    Ver información
                  </a-button>
                </li>
                <li>
                  <a-button
                    type="text"
                    :disabled="isEmailResolved(record)"
                    @click="handleOpenResolveEmailModal(record)"
                  >
                    <CheckOutlined />
                    Resolver correo
                  </a-button>
                </li>
              </ul>
            </div>
          </template>
          <a-button type="text" @click.stop><MoreOutlined /></a-button>
        </a-popover>
      </a-space>
    </template>
  </a-table>

  <TransferUser
    v-if="openTransferUser"
    v-model:open="openTransferUser"
    :selectedRows="selectedRowsTransfer"
    @update="handleUpdateData"
  />

  <TransferCampaign
    v-if="visibleTransferCampaign"
    v-model:visible="visibleTransferCampaign"
    :selectedThreads="selectedRowsTransfer"
    @update="handleUpdateData"
    type="campaign"
    title="Transferir a una campaña"
  />
  <ResolveEmail
    v-if="visibleResolve"
    v-model:open="visibleResolve"
    :multiple="true"
    :emailsIds="selectedRow"
    @update="handleUpdateData"
  />
  <!-- <UserTransferModal
    v-if="openUserTransferModal"
    v-model:open="openUserTransferModal"
    :users="transferEmailsData.agents"
    :queue="currentQueueName"
    :emailId="currentEmailId"
    @update="handleUpdateData"
  />

  <QueueTransferModalVue
    v-if="openQueueTransferModal"
    v-model:open="openQueueTransferModal"
    :queues="transferEmailsData.queues"
    :emailId="currentEmailId"
    @update="handleUpdateData"
  /> -->
</template>

<script setup lang="ts">
import { ref, computed, inject, watch, Ref } from "vue";
import { useStore } from "vuex";
import {
  InfoCircleOutlined,
  SwapOutlined,
  // EditOutlined,
  CheckOutlined,
  MoreOutlined,
  // LinkOutlined,
} from "@ant-design/icons-vue";

import { EmailState } from "@/app/shared/utils/enums";
import { useScrollResize } from "@/app/shared/composables/useScrollResize";

import ProfileImage from "@/app/shared/components/organisms/ProfileImage.vue";
import EmailStateTag from "../tags/EmailStateTag.vue";
// import UserTransferModal from "@/app/emailsManager/components/modals/transfer/UserTransferModal.vue";
// import QueueTransferModalVue from "@/app/emailsManager/components/modals/transfer/QueueTransferModal.vue";
// import PopoverChannels from "@/app/shared/components/molecules/PopoverChannels.vue";
import TicketTagsList from "@/app/shared/components/lists/TicketTagsList.vue";
import TagsList from "@/app/shared/components/lists/TagsList.vue";
import TransferUser from "@/app/emails/components/modals/transferEmail/TransferUser.vue";
import TransferCampaign from "@/app/emails/components/modals/transferEmail/TransferCampaign.vue";

import { emailsTableColumns } from "../../utils/constants";

import { emailService } from "@/app/emails/services/Email.service";
import { message } from "ant-design-vue";
import ResolveEmail from "@/app/emails/components/modals/ResolveEmail.vue";

import crownImage from "@/app/settings/assets/profile/crown.svg?url";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  loadingTable: {
    type: Boolean,
    required: true,
  },
  size: {
    type: Number,
    default: 14,
  },
});

const store = useStore();

const emit = defineEmits([
  "page-change",
  "open-ticket-history-drawer",
  "open-edit-drawer",
  "open-contact-drawer",
  "open-user-modal",
  "open-email-history-drawer",
]);

const tableRef = ref(null);
const currentTablePage = computed(() => store.getters["getTablePage"]);

const selectedRowKeys = inject("selectedTableRowKeys");
// const updateSelectedTableRowKeys = inject("updateSelectedTableRowKeys");

// const selectedRowsLastChannel = inject("selectedRowsLastChannel");
// const selectedRowsList = inject("selectedRowsList");
const selectedRowsTransfer = ref([]);
const openTransferUser = ref(false);
const visibleTransferCampaign = ref(false);
const visibleResolve = ref(false);

const selectedRow: Ref<Array<number>> = ref([]);
watch(selectedRowKeys, (newList) => {
  if (newList?.length) setNewMargin(400);
  else setNewMargin(320);
});

const { scrollStyle, setNewMargin } = useScrollResize({ headerMargin: 320 });

const selectedEmails = ref<number>(0);

// const selectedRowKeys = ref<DataType["key"][]>([]);
// const selectedRowKeys = ref<any[]>([]);

const onSelectChange = (changableRowKeys: number[], selectedRows: DataType[]) => {
  console.log("selectedRowKeys changed: ", changableRowKeys);
  selectedRowKeys.value = changableRowKeys;
  selectedEmails.value = selectedRows.length;
};

const rowSelection: TableProps["rowSelection"] = {
  selectedRowKeys: computed(() => selectedRowKeys.value),
  onChange: onSelectChange,
  onSelect: (nativeEvent: any, selected: any) => {
    console.log(`selectedRows lll: ${nativeEvent}`, "selected: ", selected);
  },
  getCheckboxProps: (record) => ({ disabled: record.statusSent === EmailState.resolved }),
};

const pagination = computed(() => ({
  total: props.data?.count,
  current: currentTablePage.value,
  pageSize: 50,
  showSizeChanger: false,
}));

const handleTableChange = (page) => {
  emit("page-change", page.current);
};

// Button actions

const handleOpenTicketHistoryDrawer = (ticket) => {
  emit("open-ticket-history-drawer", { id: ticket });
};

const handleOpenEmailHistoryDrawer = (record) => {
  record.visiblePopover = false;
  emit("open-email-history-drawer", record);
};
const handleUpdateData = () => emit("update-data");

const handleOpenEditDrawer = (email) => {
  emit("open-edit-drawer", email);
};

// Details

const handleOpenContactDrawer = (contactId, campaign) => {
  emit("open-contact-drawer", contactId, campaign);
};

const handleOpenUserModal = (userName, userId) => {
  emit("open-user-modal", { userName, userId });
};

const isEmailResolved = (record: any) => {
  return record?.statusSent === EmailState.resolved;
};

// User Icon

const getProfileIcon = (icon: string) => {
  return new URL(`../../../users/assets/profiles/${icon}`, import.meta.url).href;
};

const imageDefault = (user) => {
  const profile = user?.icon || "";
  let url = "";
  if (profile === "") {
    url = crownImage;
  } else {
    url = getProfileIcon(profile);
  }
  return url;
};

const backGroundImageColor = (user) => {
  const background = user?.icon || "";
  const typeProfile = user?.fullname;

  if (background === "") {
    return "background: #E6F7FF";
  } else if (typeProfile === "Supervisor") {
    return "background: #E6F7FF";
  } else if (typeProfile === "Agente") {
    return "background: #FFF7E6";
  }

  return "background: #E6F7FF";
};

const handleSelectTags = async (
  tags: { tagsToAdd: number[]; tagsToRemove: number[] },
  id: number
) => {
  // console.log(tags, 'tags total');
  const response = await emailService.editThreadEmail(id, {
    tag_list: tags.tagsToAdd,
    delete_tags_id: tags.tagsToRemove,
  });

  if (response.status == 200) message.success("Se ha asignado las etiquetas correctamente");

  // const response = await emailService.massiveTag([id], tags);
  // // await emailService.editThreadEmail(item.id, { tag_list: [ ...tags,  ...item.tag ]});

  // if (response.status == 200) message.success("Se ha asignado las etiquetas correctamente");

  handleUpdateData();
};

const transferEmailUser = (item: any) => {
  openTransferUser.value = true;
  selectedRowsTransfer.value = [item];
};

const transferEmailCampaign = (item: any) => {
  visibleTransferCampaign.value = true;
  selectedRowsTransfer.value = [item];
};

const handleOpenResolveEmailModal = (item: any) => {
  if (item.statusSent === EmailState.resolved) return;
  visibleResolve.value = true;
  selectedRow.value = [item.id];
};
</script>

<style lang="sass" scoped>
.contact-button
  max-width: 100%
  overflow: hidden
  text-overflow: ellipsis

.email-truncate
  display: inline-block
  max-width: 180px
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis

:deep(.contact-button > span)
  display: initial

.tag
  width: 27px
  height: 4px
  border-radius: 3.5px

.tags__container
  display: flex
  gap: 4px
  flex-wrap: wrap

.table-link-button
  padding: 0

.emails-table
  margin-top: 8px

.user_profile
  &_wrapper
    width: 28px
    height: 28px
    border-radius: 50%
    display: grid
    place-content: center

  &_picture
    width: 28px
    height: 28px
    border-radius: 50%

  &_default
    width: 28px
    height: 28px
    border-radius: 50%
    border: 1px solid $geekblue-6
    color: $geekblue-7
    //background-color: $geekblue-1
    padding: 5px


section
  display: grid
  justify-items: center
  color: $gray-6
  font-size: 20px
  margin: auto 0

.name
  display: flex
  align-items: center
  position: relative

  &__logo
    display: block
    width: 28px
    height: 28px
    background-size: cover
    background-position: center
    border-radius: 50%

    &--empty
      background-image: url('../../../entities/assets/briefcase-blue.svg')

.channels-group
  display: inline-flex
  gap: 10px
.channels-icons
  color: black
.channel-tooltip
  color: black
  width: fit-content
  ul
    list-style: none
    text-align: left
    padding: 0
    margin: 0
    li
      white-space: nowrap
      .channel-info
        padding-left: 5px
        .identifier
          color: $gray-7
.calls-tooltip
  color: black
  width: fit-content
  ul
    margin: 0
    padding-left: 20px

.agent
  filter: invert(55%) sepia(46%) saturate(1606%) hue-rotate(351deg) brightness(105%) contrast(96%)

.contact-space:deep(.ant-space-item:nth-child(2))
  min-width: 0
  flex: 1 1 auto

.popover-content
  ul
    list-style: none
    padding-left: 0
    margin: 0

    li
      button
        width: 100%
        text-align: left
        padding: 0 5px
        display: flex
        align-items: center
        gap: 5px

        &:hover
          background: #0000000A
        .icon
          height: 13px
</style>

<style scoped>
.emails-table .ant-space.ant-space-horizontal.ant-space-align-center.contact-space {
  max-width: 100% !important;
}
.emails-table .contact-space .ant-space-item {
  max-width: calc(100% - 36px) !important;
}
</style>
